import { FC } from 'react';

import { isMarkdown } from '../../lib/itemCheckers';
import { ParseHTML } from './ParseHTML';
import { ParseMarkdown } from './ParseMarkdown';

export const ParseMessageContent: FC<{ item: connect.ChatTranscriptItem }> = ({ item }) => {
  // Note: currently 'text/plain' messages from the bot can potentially include HTML, so we default to parsing HTML
  return isMarkdown(item) ? <ParseMarkdown content={item.Content} /> : <ParseHTML content={item.Content} />;
};

ParseMessageContent.displayName = 'ParseMessageContent';
